style= require('./stats.styl')
.player.header
  .shirt(title="Shirt number") #
  if !match.isDuel && this.match.sport && this.match.sport != 'golf'
    .team(title="Team") Team
  .name(title="Last name") Name
  if showPosition
    .position.col(title="Position") Pos
  .filler
  if match.hasMinutes
    .playtime(title="Minutes played") Min
  if !match.isDuel && !match.isRacing && match.sport !== 'golf'
    .rank(title="Rank") Rank
  each column in columns
    .col(
      class=column.normal,
      title=column.full
    )= column.abbr
  if match.sport === 'basket'
    .col.doubles(title="Doubles") Db
  if customSort
    .rank Order
  if context === 'confirmations'
    .rank Confirmed?
.rows
  ft-button(
    (click)=this.toggleCustomSort()
  )=this.customSort ? 'Hide Custom Sort' : 'Show Custom Sort'
  each item in this.teamLineup()
    - var lineup = item.lineup
    - var shirt = lineup.player && (lineup.player.shirt || lineup.player.shirt === 0) ? lineup.player.shirt : '?' 
    - var scorePosition = lineup.scorePosition
    .player(class=item.state)
      if scorePosition
        .shirt(title=scorePosition) +
      else 
        .shirt= shirt + '.'
      - this.cleanStats(lineup)
      if !match.isDuel && this.match?.sport != 'golf'
        .team(title=lineup.team.name)= lineup.team.short
      a.name(
        title=lineup.player.fullName,
        href=link('edit-player', lineup),
        target="_blank"
      )
        = lineup.player.name
      if showPosition
        .position.col(title=lineup.player.position)= lineup.player.pos
      .filler
      if match.hasMinutes && editMode && match.canEditMinutes
        .playtime
          input(
            type="number",
            value=lineup.duration / 60,
            (input)=item.lineup.duration = e.target.value * 60
          )
      else if match.hasMinutes
        .playtime(title="Minutes played")= window.Math.ceil(lineup.duration / 60 || 0)
      if !match.isDuel && !match.isRacing && match.sport !== 'golf'
        - var rank = lineup.stats.rank
        .rank(class={zero: !rank})= rank
      each column in columns
        .col(class=this.columnClass(lineup, column))
          if this.canEditLineup(lineup) && this.canEditStats(column)
            if column.enum
              select((change)=this.setStat(item.lineup, column, e.target.value))
                option(value="") -
                each option in column.enum
                  option(selected=lineup.stats[column.normal] === option)= option
            else
              input(
                type="number",
                value=lineup.stats[column.normal],
                (input)=this.setStat(item.lineup, column, e.target.value)
              )
          else
            span= this.calcStat(lineup, column)
      if context === 'confirmations'
        .rank
          input(
            type="checkbox",
            name="isConfirmed",
            (input)=this.toggleConfirmLineup(lineup)
            )
          =lineup.stats.confirmed ? 'Y' : 'N'      

      if match.sport === 'basket'
        .col.doubles
          if lineup.stats.tripleDouble
            .triple III
          else if lineup.stats.doubleDouble
            .double II
          else
            .zero -
      if this.customSort
         if this.editMode
          .col.rank
            input(
              type="number",
              value=lineup.lane,
              (input)=this.setOrder(item.lineup, e.target.value)
            )
         else 
          .col.rank= lineup.lane
